module.exports = __webpack_public_path__ + "afcb26e7b0eee88a130cc90d6a43cdaf.svg";